import { matchPath } from 'react-router-dom';

import { orderDetailsPageRoutePath } from '~/routes/order-details-page/orderDetailsPageRoute.path';

import { type OrderDetailsPageRoute } from '../types/orderDetailsPageScanSubmit.type';

interface OrderDetailsPageRouteParams {
  batchEntryId?: string;
  orderId: string;
}

export const resolveOrderDetailsPageRoute = (
  rawPath?: string,
): OrderDetailsPageRoute | undefined => {
  if (!rawPath) return undefined;

  const match = matchPath<OrderDetailsPageRouteParams>(rawPath, {
    exact: true,
    path: orderDetailsPageRoutePath,
  });

  // The shared path also matches an order without a shipment; scans need the batch entry.
  if (!match?.params.batchEntryId) return undefined;

  return { batchEntryId: match.params.batchEntryId, orderObjectId: match.params.orderId };
};
